import React, { useState } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';

export default function ListManagerModal({ open, onClose, title, items, addItem, updateItem, deleteItem }) {
  const [editingIndex, setEditingIndex] = useState(null);
  const [inputLabel, setInputLabel] = useState('');

  if (!open) return null;

  const handleSave = () => {
    if (editingIndex === null) return;
    const oldLabel = items[editingIndex];
    const trimmed = inputLabel.trim();
    if (trimmed && trimmed !== oldLabel) {
      updateItem(oldLabel, trimmed);
    }
    setEditingIndex(null);
    setInputLabel('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">Manage {title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700"><X size={20}/></button>
        </div>

        <div className="space-y-3 max-h-80 overflow-y-auto">
          {items.map((label, idx) => (
            <div key={label} className="flex items-center gap-2">
              {editingIndex === idx ? (
                <>
                  <input
                    value={inputLabel}
                    onChange={(e)=>setInputLabel(e.target.value)}
                    className="flex-1 px-2 py-1 border rounded"
                    onKeyDown={(e)=>{if(e.key==='Enter') handleSave();}}
                  />
                  <button onClick={handleSave} className="text-blue-600 font-medium">Save</button>
                  <button onClick={()=>{setEditingIndex(null); setInputLabel('');}} className="text-gray-500">Cancel</button>
                </>
              ) : (
                <>
                  <span className="flex-1">{label}</span>
                  <button onClick={()=>{setEditingIndex(idx); setInputLabel(label);}} className="text-blue-600 text-sm">Edit</button>
                  <button onClick={()=>deleteItem(label)} className="text-red-600"><Trash2 size={14}/></button>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="mt-4 flex gap-2 items-center">
          <input value={inputLabel} onChange={(e)=>setInputLabel(e.target.value)} placeholder={`New ${title.toLowerCase()}`} className="flex-1 px-3 py-2 border rounded" />
          <button onClick={()=>{ addItem(inputLabel.trim()); setInputLabel(''); }} className="bg-blue-600 text-white px-3 py-2 rounded flex items-center gap-1"><Plus size={16}/>Add</button>
        </div>
      </div>
    </div>
  );
} 